export var TRANSPARENT_BLUR_BG_SX = {
    backgroundColor: "#1D293940",
    backdropFilter: "blur(20px)",
    borderTop: "1px solid",
    borderImageSource: "linear-gradient(90deg, rgba(208, 213, 221, 0) 0%, rgba(208, 213, 221, 0.15) 14.55%, rgba(208, 213, 221, 0.15) 83.49%, rgba(208, 213, 221, 0) 100%)",
};
export var DEFAULT_IMAGES_360_PATH = "images360/default_img";
export var IMAGE_SIZE_SCALE;
(function (IMAGE_SIZE_SCALE) {
    IMAGE_SIZE_SCALE["preview"] = "preview";
    IMAGE_SIZE_SCALE["original"] = "original";
})(IMAGE_SIZE_SCALE || (IMAGE_SIZE_SCALE = {}));
export var IMAGE_SIZE_FOLDERS;
(function (IMAGE_SIZE_FOLDERS) {
    IMAGE_SIZE_FOLDERS["preview"] = "paul_live_gallery";
    IMAGE_SIZE_FOLDERS["original"] = "equirectangular";
})(IMAGE_SIZE_FOLDERS || (IMAGE_SIZE_FOLDERS = {}));
export var IMAGE_FORMATS = {
    jpg: "jpg",
    webp: "webp",
};
export var MEDIA_OUTPUT_CHANNEL;
(function (MEDIA_OUTPUT_CHANNEL) {
    MEDIA_OUTPUT_CHANNEL["entry"] = "360 Entry";
    MEDIA_OUTPUT_CHANNEL["gallery"] = "Gallery";
})(MEDIA_OUTPUT_CHANNEL || (MEDIA_OUTPUT_CHANNEL = {}));
export var SPHERE_CORRECTION_DEFAULT = {
    pan: 0,
    tilt: 0,
    roll: 0,
};
export var DEFAULT_PARAMS_IMAGE_360 = {
    pitch: 0,
    yaw: 0,
    zoom: 0,
};
